import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const certificate = (payload) => httpClient.post(apis.CERTIFICATE, payload);
export const identificationconfig = () => httpClient.get(apis.IDENTIFICATION_CONFIG);
export const passportsubmit = (payload) => httpClient.post(apis.PASSPORT_SUBMIT, payload);
export const idcheckandsave = (payload) => httpClient.post(apis.ID_CHECK_AND_SAVE, payload);
export const idrefuse = () => httpClient.get(apis.ID_REFUSE);
export const idrecall = () => httpClient.get(apis.ID_RECALL);
